<template>
  <div id="tags-view-container" class="tags-view-container" v-show="showTagsView">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link v-for="tag in visitedViews" ref="tag" :key="tag.path" :class="isActive(tag) ? 'active' : ''" :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" tag="span" class="tags-view-item" :style="activeStyle(tag)" @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''" @contextmenu.prevent.native="openMenu(tag, $event)">
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)"><i class="el-icon-refresh-right"></i> 刷新页面</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)"><i class="el-icon-close"></i> 关闭当前</li>
      <li @click="closeOthersTags"><i class="el-icon-circle-close"></i> 关闭其他</li>
      <li v-if="!isFirstView()" @click="closeLeftTags"><i class="el-icon-back"></i> 关闭左侧</li>
      <li v-if="!isLastView()" @click="closeRightTags"><i class="el-icon-right"></i> 关闭右侧</li>
      <li @click="closeAllTags(selectedTag)"><i class="el-icon-circle-close"></i> 全部关闭</li>
    </ul>
  </div>
</template>

<script>
  import ScrollPane from './ScrollPane';
  import path from 'path';

  export default {
    components: { ScrollPane },
    data() {
      return {
        visible: false,
        top: 0,
        left: 0,
        selectedTag: {},
        affixTags: [],
      };
    },
    computed: {
      visitedViews() {
        return this.$store.state.tagsView.visitedViews;
      },
      routes() {
        return this.$store.state.permission.routes;
      },
      theme() {
        return this.$store.state.settings.theme;
      },
      showTagsView() {
        // 只隐藏“添加任务”页面（支持带斜杠结尾的情况），其它页面始终显示
        try {
          const path = this.$route.path.replace(/\/+$/, '');
          if (path === '/learningManagement/add-task') {
            return false;
          }
        } catch (e) {}
        return true;
      },
    },
    watch: {
      $route() {
        this.addTags();
        this.moveToCurrentTag();
        // 触发 showTagsView 重新计算
        this.$forceUpdate();
      },
      visible(value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu);
        } else {
          document.body.removeEventListener('click', this.closeMenu);
        }
      },
    },
    mounted() {
      this.initTags();
      this.addTags();
    },
    methods: {
      isActive(route) {
        return route.path === this.$route.path;
      },
      activeStyle(tag) {
        if (!this.isActive(tag)) return {};
        return {
          'background-color': 'rgba(23, 130, 239, 0.1)',
          'border-color': this.theme,
          color: this.theme,
        };
      },
      isAffix(tag) {
        return tag.meta && tag.meta.affix;
      },
      isFirstView() {
        try {
          return this.selectedTag.fullPath === '/index' || this.selectedTag.fullPath === this.visitedViews[1].fullPath;
        } catch (err) {
          return false;
        }
      },
      isLastView() {
        try {
          return this.selectedTag.fullPath === this.visitedViews[this.visitedViews.length - 1].fullPath;
        } catch (err) {
          return false;
        }
      },
      filterAffixTags(routes, basePath = '/') {
        let tags = [];
        routes.forEach((route) => {
          if (route.meta && route.meta.affix) {
            const tagPath = path.resolve(basePath, route.path);
            tags.push({
              fullPath: tagPath,
              path: tagPath,
              name: route.name,
              meta: { ...route.meta },
            });
          }
          if (route.children) {
            const tempTags = this.filterAffixTags(route.children, route.path);
            if (tempTags.length >= 1) {
              tags = [...tags, ...tempTags];
            }
          }
        });
        return tags;
      },
      initTags() {
        const affixTags = (this.affixTags = this.filterAffixTags(this.routes));
        for (const tag of affixTags) {
          // Must have tag name
          if (tag.name) {
            this.$store.dispatch('tagsView/addVisitedView', tag);
          }
        }
      },
      addTags() {
        const { name } = this.$route;
        if (name) {
          this.$store.dispatch('tagsView/addView', this.$route);
          if (this.$route.meta.link) {
            this.$store.dispatch('tagsView/addIframeView', this.$route);
          }
        }
        return false;
      },
      moveToCurrentTag() {
        const tags = this.$refs.tag;
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag);
              // when query is different then update
              if (tag.to.fullPath !== this.$route.fullPath) {
                this.$store.dispatch('tagsView/updateVisitedView', this.$route);
              }
              break;
            }
          }
        });
      },
      refreshSelectedTag(view) {
        this.$tab.refreshPage(view);
        if (this.$route.meta.link) {
          this.$store.dispatch('tagsView/delIframeView', this.$route);
        }
      },
      closeSelectedTag(view) {
        this.$tab.closePage(view).then(({ visitedViews }) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViews, view);
          }
        });
      },
      closeRightTags() {
        this.$tab.closeRightPage(this.selectedTag).then((visitedViews) => {
          if (!visitedViews.find((i) => i.fullPath === this.$route.fullPath)) {
            this.toLastView(visitedViews);
          }
        });
      },
      closeLeftTags() {
        this.$tab.closeLeftPage(this.selectedTag).then((visitedViews) => {
          if (!visitedViews.find((i) => i.fullPath === this.$route.fullPath)) {
            this.toLastView(visitedViews);
          }
        });
      },
      closeOthersTags() {
        this.$router.push(this.selectedTag.fullPath);
        this.$tab.closeOtherPage(this.selectedTag).then(() => {
          this.moveToCurrentTag();
        });
      },
      closeAllTags(view) {
        this.$tab.closeAllPage().then(({ visitedViews }) => {
          if (this.affixTags.some((tag) => tag.path === this.$route.path)) {
            return;
          }
          this.toLastView(visitedViews, view);
        });
      },
      toLastView(visitedViews, view) {
        const latestView = visitedViews.slice(-1)[0];
        if (latestView) {
          this.$router.push(latestView.fullPath);
        } else {
          // now the default is to redirect to the home page if there is no tags-view,
          // you can adjust it according to your needs.
          if (view.name === 'Dashboard') {
            // to reload home page
            this.$router.replace({ path: '/redirect' + view.fullPath });
          } else {
            this.$router.push('/');
          }
        }
      },
      openMenu(tag, e) {
        const menuMinWidth = 105;
        const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
        const offsetWidth = this.$el.offsetWidth; // container width
        const maxLeft = offsetWidth - menuMinWidth; // left boundary
        const left = e.clientX - offsetLeft - 40; // 15: margin right

        if (left > maxLeft) {
          this.left = maxLeft;
        } else {
          this.left = left;
        }

        this.top = e.clientY - 30;
        this.visible = true;
        this.selectedTag = tag;
      },
      closeMenu() {
        this.visible = false;
      },
      handleScroll() {
        this.closeMenu();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tags-view-container {
    height: 55px;
    width: 100%;
    background: #fff;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 24px;
      right: 24px;
      bottom: 0;
      height: 0;
      border-bottom: 1px dashed #eff3fc;
      pointer-events: none;
      z-index: 1;
    }
    .tags-view-wrapper {
      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        top: -2px;
        height: 24px;
        background-color: #f2f4f8;
        border-radius: 3px;
        line-height: 24px;
        color: #2e3e4f;
        border-right: 0;
        padding: 0 8px;
        font-size: 12px;
        &:first-of-type {
          margin-left: 0 !important;
        }
        margin-right: 6px;
        &.active {
          border: 0;
          background-color: #1a85f9;
          font-size: 12px;
          color: #fff;
        }
        .el-icon-close {
          width: 8px;
          height: 8px;
          color: #424f5f;
          text-align: center;
          margin-right: 4px;
          margin-left: 10px;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          transform-origin: 100% 50%;
        }
      }
    }
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 3000;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
</style>
